import React, { useState, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { FileText } from 'lucide-react';
import '../styles/rules-page.css';

const RULES_FILES = {
  it: 'DIOS10 Rules v1.0.3 ITA.pdf',
  en: 'DIOS10 Rules v1.0.3 ENG.pdf',
  es: 'DIOS10 Rules v1.0.3 SPA.pdf',
  fr: 'DIOS10 RULES v1.0.3 FR.pdf',
  tr: 'DIOS10 Rules v1.0.3 TR.pdf'
};
const RULES_FALLBACK = 'DIOS10 Rules v1.0.3 ENG.pdf';

const MOBILE_BREAKPOINT = 768;

const RulesPage = () => {
  const { t, language } = useLanguage();
  const [isMobile, setIsMobile] = useState(false);
  const pdfUrl = `${process.env.PUBLIC_URL || ''}/rules/${encodeURIComponent(RULES_FILES[language] || RULES_FALLBACK)}`;

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  if (isMobile) {
    const bgImage = `linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.6) 100%), url('${process.env.PUBLIC_URL || ''}/images/homebg.png')`;
    return (
      <main
        className="rules-page rules-page-mobile"
        style={{
          backgroundImage: bgImage,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="rules-page-mobile-card">
          <FileText className="rules-page-mobile-icon" />
          <h2 className="rules-page-mobile-title">{t('rules.mobileTitle')}</h2>
          <p className="rules-page-mobile-desc">{t('rules.mobileDesc')}</p>
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="rules-page-mobile-btn"
          >
            {t('rules.openPdf')}
          </a>
        </div>
      </main>
    );
  }

  return (
    <main className="rules-page">
      <div className="rules-page-container">
        <iframe
          src={pdfUrl}
          title="Regolamento DIOS10"
          className="rules-pdf-iframe"
        />
      </div>
    </main>
  );
};

export default RulesPage;
